import { Offer } from 'rest-client';

export class SetOfferAction {
  static readonly type = '[OFFER] Set offer';
  constructor(public offer: Offer) {}
}

export class SetServiceRequestAction {
  static readonly type = '[OFFER] Set service_request';
  constructor(public service_request: string) {}
}

export class SetTiresServiceRequestAction {
  static readonly type = '[OFFER] Set customized_tires_request';
  constructor(public customized_tires_request: boolean) {}
}

export class RemoveOfferAction {
  static readonly type = '[OFFER] Remove offer';
}

export class RemoveServiceRequestAction {
  static readonly type = '[OFFER] Remove service_request';
}

export class RemoveTiresServiceRequestAction {
  static readonly type = '[OFFER] Remove customized_tires_request';
}
